import { FC } from "react";
import { styled } from "@mui/material/styles";
import { OutlinedInput, InputAdornment, Icon } from "@mui/material";
import IngredientsTable from "../tables/IngredientsTable";
import { modalHide, modalShow } from "app/App/actions";
import trans from "helpers/trans";
import { useDispatch } from "react-redux";
import { IIngredients, IngredientsProps } from "../interfaces";

export const StyledOutlinedInput = styled(OutlinedInput)({
    width: "100%",
    background: "#fff",
    marginBottom: 16,
});

const Ingredients: FC<IngredientsProps> = ({ ingredients, onChange }) => {
    const dispatch = useDispatch();

    const handleOnDelete = (idx: number) => {
        onChange(
            ingredients.filter(
                (item: IIngredients, itemIdx: number) => itemIdx !== idx
            )
        );
    };

    const handleOnSearchClick = () => {
        dispatch(
            modalShow("IngredientsSearchModal", {
                selectIngredient: addSelectedIngredient,
            })
        );
    };

    const addSelectedIngredient = (item: any) => {
        dispatch(modalHide("IngredientsSearchModal"));
        if (
            ingredients.filter(
                (ingredient: any) => ingredient.ingredient_id === item.id
            ).length > 0
        ) {
            alert(trans("inv.ingredients.component.ingredients.alert"));
            return;
        }

        onChange([
            ...ingredients,
            {
                ingredient_id: item.id,
                cost: 0,
                quantity: 0,
                unit: item.unit,
                ingredient: item,
                waste: 0,
            },
        ]);
    };

    return (
        <>
            <StyledOutlinedInput
                placeholder={trans("global.input.search")}
                size="small"
                type="button"
                onClick={handleOnSearchClick}
                sx={{
                    "&:hover": {
                        cursor: "pointer",
                    },
                }}
                startAdornment={
                    <InputAdornment position="start">
                        <Icon sx={{ color: "grey.400", mr: 2 }}>search</Icon>{" "}
                        {trans("global.input.search")}
                    </InputAdornment>
                }
                margin="dense"
            />

            <IngredientsTable
                rows={ingredients}
                onDelete={handleOnDelete}
                onChange={onChange}
            />
        </>
    );
};

export default Ingredients;
